import { makeAutoObservable } from "mobx";
import { IdentifiableMap, RMutableMap, } from "../../collections";
import { Quantity } from "../../core";
import { ModifierInstance } from "../ProductInstance";
export class ModifierInstanceCreator {
    constructor(params) {
        this.behaviour = params.behaviour;
        this.editorHidden = params.editorHidden;
        if (params.modifierType.behaviour !== this.behaviour) {
            throw new Error("Modifier behaviour mismatch");
        }
        this.modifierType = params.modifierType;
        this.modifierSettings = params.modifierSettings;
        this.itemQuantities = params.itemQuantities;
        this.itemCreators = params.itemCreators;
        this.editability = params.editability;
        makeAutoObservable(this);
    }
    get typeId() {
        return this.modifierType.id;
    }
    get modifierInstance() {
        const items = IdentifiableMap.fromIterable("variantKey", this.itemCreators.objects.map((modifierItemInstanceCreator) => modifierItemInstanceCreator.modifierItemInstance));
        return new ModifierInstance({
            modifierType: this.modifierType,
            freeItems: this.modifierSettings.freeItems,
            items,
        });
    }
    selectInferredDefaults() {
        if (!this.itemCreators.objects.some((itemInstance) => itemInstance.isSelected) &&
            this.modifierType.minItems.isOne) {
            const availableItems = this.itemCreators.filter((itemInstanceCreator) => itemInstanceCreator.isEditable);
            if (availableItems.size === 1) {
                availableItems.sample.select();
            }
        }
    }
    setSelectedByVariantKeys(selectedVariantKeys) {
        var _a;
        const counts = RMutableMap.empty({
            makeAutoObservable: false,
        });
        for (const variantId of selectedVariantKeys) {
            const count = counts.getOrCreate(variantId, () => Quantity.Zero);
            counts.update(variantId, count.incremented());
        }
        for (const itemCreator of this.itemCreators.objects) {
            const count = (_a = counts.find(itemCreator.variantKey)) !== null && _a !== void 0 ? _a : Quantity.Zero;
            this.itemQuantities.setQuantity(itemCreator.variantKey, count);
        }
    }
}
